export const initialState = {
  selectedCourse: null,
};

export const setSelectedCourse = (state, action) => {
  state.selectedCourse = action.payload;
  return state;
};

export const clearSelectedCourse = (state) => {
  state.selectedCourse = null;
  return state;
};

export const reducers = {
  setSelectedCourse,
  clearSelectedCourse,
};
